import {
    type FragmentType,
    getFragmentData,
    graphql
} from '~/resources/graphql'
import type { InjectionKey } from 'vue'
import { computed, inject, provide } from 'vue'

export const UseLoginModalOrganizationFragment = graphql(`
    fragment UseLoginModalOrganizationFragment on Organization {
        rememberMeDefault
        onlineProfileAgeMinimum
        loginContactMethodDisplayOrder
        facilityLocationGroups {
            id
            name
            facilities {
                id
                label
            }
        }
    }
`)

type LoginModalOrganizationFragment = FragmentType<
    typeof UseLoginModalOrganizationFragment
>

const loginModalOrganizationInjectionKey: InjectionKey<LoginModalOrganizationFragment> =
    Symbol('loginModalOrganizationInjectionKey')

export function provideLoginModalOrganizationFragment(
    organization: LoginModalOrganizationFragment
) {
    provide(loginModalOrganizationInjectionKey, organization)
}

export function useLoginModalOrganization() {
    const organization = inject(loginModalOrganizationInjectionKey)

    if (organization === undefined) {
        throw new Error('No Login Modal Organization')
    }

    return computed(() => {
        return getFragmentData(UseLoginModalOrganizationFragment, organization)
    })
}
